import * as React from 'react';
import { Button as Button$1 } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';

const CmsButton = ({ component , page  })=>{
    const { document: documentRef  } = component.getModels();
    const document = documentRef && page.getContent(documentRef);
    if (!document) {
        return null;
    }
    const { buttonStyling , contentType , displayName , iconImage , newWindow , url  } = document.getData();
    const hrefTarget = newWindow ? '_blank' : '_self';
    if (!url || !displayName) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "br-button",
        "data-t": "br-button"
    }, /*#__PURE__*/ React.createElement(Button$1, {
        caption: displayName,
        color: buttonStyling,
        icon: iconImage,
        href: url,
        hrefTarget: hrefTarget,
        type: contentType
    }));
};
var Button = compose(withBreakpointVisibility, withEditableContent, withAnchor)(CmsButton);

export { CmsButton, Button as default };
//# sourceMappingURL=Button.js.map
